import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal, { SectionLabel } from "../components/Reveal";
import PageHero from "../components/PageHero";
import { BLOG } from "../lib/site";

export default function Blog() {
  const [featured, ...rest] = BLOG;
  return (
    <>
      <PageHero
        label="Blog & Resources"
        title={<>Ideas on raising <em className="font-italic-accent italic gold-text">confident</em> communicators.</>}
        subtitle="Perspectives on communication, confidence and child development — written for parents who want more for their children than marks alone."
      />

      {/* FEATURED */}
      <section data-testid="blog-featured" className="py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <Link
              to={`/blog/${featured.slug}`}
              data-testid={`blog-featured-${featured.slug}`}
              className="lux-card group grid lg:grid-cols-2 overflow-hidden"
            >
              <div className="relative overflow-hidden aspect-[16/11] lg:aspect-auto">
                <img
                  src={featured.image}
                  alt={featured.title}
                  className="absolute inset-0 w-full h-full object-cover grayscale-[15%] group-hover:grayscale-0 group-hover:scale-[1.04] transition-all duration-[1.2s]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              </div>
              <div className="p-9 lg:p-12 flex flex-col justify-center">
                <div className="flex items-center gap-4">
                  <span className="section-label">{featured.category}</span>
                  <span className="font-sans text-xs text-white/40">{featured.date} · {featured.readTime}</span>
                </div>
                <h2 className="mt-6 font-serif text-3xl lg:text-4xl text-white font-light leading-[1.1]">
                  {featured.title}
                </h2>
                <p className="mt-5 font-sans text-base text-white/60 leading-relaxed">
                  {featured.excerpt}
                </p>
                <span className="mt-8 inline-flex items-center gap-2 text-[#d4af37] font-sans text-[11px] tracking-[0.28em] uppercase">
                  Read Article <ArrowUpRight size={14} />
                </span>
              </div>
            </Link>
          </Reveal>
        </div>
      </section>

      {/* GRID */}
      <section data-testid="blog-grid" className="pb-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {rest.map((post, i) => (
              <Reveal key={post.slug} delay={i * 0.06}>
                <Link
                  to={`/blog/${post.slug}`}
                  data-testid={`blog-card-${post.slug}`}
                  className="lux-card group block h-full"
                >
                  <div className="relative overflow-hidden aspect-[16/10]">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="absolute inset-0 w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 group-hover:scale-[1.04] transition-all duration-[1.2s]"
                    />
                    <div className="absolute top-5 left-5 section-label bg-black/60 backdrop-blur px-3 py-1">
                      {post.category}
                    </div>
                  </div>
                  <div className="p-7">
                    <div className="font-sans text-xs text-white/40">{post.date} · {post.readTime}</div>
                    <h3 className="mt-3 font-serif text-2xl text-white font-light leading-snug">
                      {post.title}
                    </h3>
                    <p className="mt-3 font-sans text-sm text-white/55 leading-relaxed line-clamp-3">
                      {post.excerpt}
                    </p>
                    <span className="mt-5 inline-flex items-center gap-2 text-[#d4af37] font-sans text-[11px] tracking-[0.28em] uppercase">
                      Read <ArrowUpRight size={14} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
